import { styled } from '@mui/system';
import { Card as CardMUI } from '@mui/material';
import { theme } from 'oems/theme';

export const Card = styled(CardMUI)`
  padding: 30px 24px;
`;

export const Title = styled('h2')`
  color: ${theme.palette.text.dark};
  font-weight: 700;
  font-size: 18px;
  line-height: normal;
  margin-bottom: 24px;
`;
